import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminProvider, useAdmin } from '../context/AdminContext';
import AdminLayout from '../components/admin/AdminLayout';
import AdminLogin from '../pages/admin/AdminLogin';
import AdminDashboard from '../pages/admin/AdminDashboard';
import ContestManager from '../pages/admin/ContestManager';
import PaymentManager from '../pages/admin/PaymentManager';
import WinnerManager from '../pages/admin/WinnerManager';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAdmin();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // BYPASS: Always allow access for now
  console.log('BYPASS: Protected route - always allowing access');
  return children;

  // Original logic (commented out for bypass)
  // if (!isAuthenticated) {
  //   return <Navigate to="/admin/login" replace />;
  // }
  // return children;
};

// Public Route Component (for login page)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAdmin();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

const AdminRoutes = () => {
  return (
    <AdminProvider>
      <Routes>
        <Route 
          path="login" 
          element={
            <PublicRoute>
              <AdminLogin />
            </PublicRoute>
          } 
        />
        
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="contests" element={<ContestManager />} />
          <Route path="payments" element={<PaymentManager />} />
          <Route path="winners" element={<WinnerManager />} />
        </Route>
        
        {/* Catch all admin routes and redirect to dashboard */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </AdminProvider>
  );
};

export default AdminRoutes;